export default __webpack_public_path__ + "static/client1-d42e5bd8184cb090500766d786d3e8a8.png";